var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-overlay',{attrs:{"show":_vm.loading,"opacity":"0.99"}},[_c('v-data-table',{attrs:{"dense":"","headers":_vm.headers,"items":_vm.residents,"footer-props":{
        'items-per-page-options': [100, 200, 300],
        'items-per-page-text': 'Mostrar',
      }},scopedSlots:_vm._u([{key:"item.status_type_name",fn:function(ref){
      var item = ref.item;
return [_vm._v(_vm._s(item.active ? item.status_type_name : "Inativo"))]}},{key:"item.date_of_birth",fn:function(ref){
      var item = ref.item;
return [_c('td',[_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.html",modifiers:{"html":true}}],staticClass:"text-primary",attrs:{"title":("Data de nascimento <br /> " + (_vm.formatDate(
              item.date_of_birth,
              false
            )))}},[_vm._v(_vm._s(_vm.getAge(item.date_of_birth))+" anos")])])]}}],null,true)})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }